
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'


import { Core } from '../core/core'
import { SeAvatarModule, SE_AVATAR_MODULE_BUNDLE } from '../avatar/avatar.module'
import { SeIconModule, SE_ICON_MODULE_BUNDLE } from '../icon/icon.module'

import { SePersonaAvatarComponent } from './persona-avatar.component'

@NgModule({
  declarations: [
    SePersonaAvatarComponent,
  ],
  imports: [
	CommonModule, 
    SeAvatarModule,
    SeIconModule,
  ],
  exports: [
    SePersonaAvatarComponent,
  ]
})
export class SePersonaAvatarModule { }

export const SE_PERSONA_AVATAR_MODULE_BUNDLE = `${Core.ANGULAR_MODULE}.personaAvatar`

